module.exports = __webpack_public_path__ + "img/event-slider-1.37b9b873.svg";